function getEvents(pageId) {
  if (
    process.env.STORYBOOK_DISABLE_ANIMATIONS === "1" ||
    process.env.STORYBOOK_DISABLE_ANIMATIONS
  ) {
    return {};
  }
  return {
    events: {
      e: {
        id: "e",
        name: "",
        animationType: "custom",
        eventTypeId: "SCROLLING_IN_VIEW",
        action: {
          id: "",
          actionTypeId: "GENERAL_CONTINUOUS_ACTION",
          config: { actionListId: "a", affectedElements: {}, duration: 0 },
        },
        mediaQueries: ["main", "medium"],
        target: {
          id: `${pageId}|0583e246-663c-ebdc-a5f5-41bffee90e73`,
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
        targets: [
          {
            id: `${pageId}|0583e246-663c-ebdc-a5f5-41bffee90e73`,
            appliesTo: "ELEMENT",
            styleBlockIds: [],
          },
        ],
        config: [
          {
            continuousParameterGroupId: "a-p",
            smoothing: 50,
            startsEntering: true,
            addStartOffset: false,
            addOffsetValue: 50,
            startsExiting: false,
            addEndOffset: false,
            endOffsetValue: 50,
          },
        ],
        createdOn: 1690982554510,
      },
      "e-2": {
        id: "e-2",
        name: "",
        animationType: "custom",
        eventTypeId: "SCROLLING_IN_VIEW",
        action: {
          id: "",
          actionTypeId: "GENERAL_CONTINUOUS_ACTION",
          config: { actionListId: "a-2", affectedElements: {}, duration: 0 },
        },
        mediaQueries: ["small", "tiny"],
        target: {
          id: `${pageId}|0583e246-663c-ebdc-a5f5-41bffee90e73`,
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
        targets: [
          {
            id: `${pageId}|0583e246-663c-ebdc-a5f5-41bffee90e73`,
            appliesTo: "ELEMENT",
            styleBlockIds: [],
          },
        ],
        config: [
          {
            continuousParameterGroupId: "a-2-p",
            smoothing: 50,
            startsEntering: true,
            addStartOffset: false,
            addOffsetValue: 50,
            startsExiting: false,
            addEndOffset: false,
            endOffsetValue: 50,
          },
        ],
        createdOn: 1691045399419,
      },
    },
    actionLists: {
      a: {
        id: "a",
        title: "Layout 415 Card [Scroll] [Desktop]",
        continuousParameterGroups: [
          {
            id: "a-p",
            type: "SCROLL_PROGRESS",
            parameterLabel: "Scroll",
            continuousActionGroups: [
              {
                keyframe: 0,
                actionItems: [
                  {
                    id: "a-n",
                    actionTypeId: "TRANSFORM_ROTATE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout415_card.card-0",
                        selectorGuids: [
                          "50c8a354-473a-4c1c-cd50-76f55858905a",
                          "50c8a354-473a-4c1c-cd50-76f55858905f",
                        ],
                      },
                      zValue: 0,
                      xUnit: "DEG",
                      yUnit: "DEG",
                      zUnit: "deg",
                    },
                  },
                  {
                    id: "a-n-2",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout415_card.card-0",
                        selectorGuids: [
                          "50c8a354-473a-4c1c-cd50-76f55858905a",
                          "50c8a354-473a-4c1c-cd50-76f55858905f",
                        ],
                      },
                      xValue: 0,
                      yValue: 0,
                      xUnit: "vw",
                      yUnit: "vh",
                      zUnit: "PX",
                    },
                  },
                ],
              },
              {
                keyframe: 22,
                actionItems: [
                  {
                    id: "a-n-3",
                    actionTypeId: "TRANSFORM_ROTATE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout415_card.card-0",
                        selectorGuids: [
                          "50c8a354-473a-4c1c-cd50-76f55858905a",
                          "50c8a354-473a-4c1c-cd50-76f55858905f",
                        ],
                      },
                      zValue: -30,
                      xUnit: "DEG",
                      yUnit: "DEG",
                      zUnit: "deg",
                    },
                  },
                  {
                    id: "a-n-4",
                    actionTypeId: "TRANSFORM_ROTATE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout415_card.card-1",
                        selectorGuids: [
                          "50c8a354-473a-4c1c-cd50-76f55858905a",
                          "50c8a354-473a-4c1c-cd50-76f55858905d",
                        ],
                      },
                      zValue: 3,
                      xUnit: "DEG",
                      yUnit: "DEG",
                      zUnit: "deg",
                    },
                  },
                  {
                    id: "a-n-5",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout415_card.card-0",
                        selectorGuids: [
                          "50c8a354-473a-4c1c-cd50-76f55858905a",
                          "50c8a354-473a-4c1c-cd50-76f55858905f",
                        ],
                      },
                      xValue: -10,
                      yValue: -100,
                      xUnit: "vw",
                      yUnit: "vh",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-n-6",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout415_card.card-1",
                        selectorGuids: [
                          "50c8a354-473a-4c1c-cd50-76f55858905a",
                          "50c8a354-473a-4c1c-cd50-76f55858905d",
                        ],
                      },
                      xValue: 0,
                      yValue: 0,
                      zValue: null,
                      xUnit: "vw",
                      yUnit: "vh",
                      zUnit: "px",
                    },
                  },
                ],
              },
              {
                keyframe: 44,
                actionItems: [
                  {
                    id: "a-n-7",
                    actionTypeId: "TRANSFORM_ROTATE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout415_card.card-1",
                        selectorGuids: [
                          "50c8a354-473a-4c1c-cd50-76f55858905a",
                          "50c8a354-473a-4c1c-cd50-76f55858905d",
                        ],
                      },
                      zValue: -30,
                      xUnit: "DEG",
                      yUnit: "DEG",
                      zUnit: "deg",
                    },
                  },
                  {
                    id: "a-n-8",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout415_card.card-1",
                        selectorGuids: [
                          "50c8a354-473a-4c1c-cd50-76f55858905a",
                          "50c8a354-473a-4c1c-cd50-76f55858905d",
                        ],
                      },
                      xValue: -10,
                      yValue: -100,
                      zValue: null,
                      xUnit: "vw",
                      yUnit: "vh",
                      zUnit: "vh",
                    },
                  },
                  {
                    id: "a-n-9",
                    actionTypeId: "TRANSFORM_ROTATE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout415_card.card-2",
                        selectorGuids: [
                          "50c8a354-473a-4c1c-cd50-76f55858905a",
                          "50c8a354-473a-4c1c-cd50-76f55858905e",
                        ],
                      },
                      zValue: 6,
                      xUnit: "DEG",
                      yUnit: "DEG",
                      zUnit: "deg",
                    },
                  },
                  {
                    id: "a-n-10",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout415_card.card-2",
                        selectorGuids: [
                          "50c8a354-473a-4c1c-cd50-76f55858905a",
                          "50c8a354-473a-4c1c-cd50-76f55858905e",
                        ],
                      },
                      xValue: 0,
                      yValue: 0,
                      xUnit: "vw",
                      yUnit: "vh",
                      zUnit: "PX",
                    },
                  },
                ],
              },
              {
                keyframe: 66,
                actionItems: [
                  {
                    id: "a-n-11",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout415_card.card-2",
                        selectorGuids: [
                          "50c8a354-473a-4c1c-cd50-76f55858905a",
                          "50c8a354-473a-4c1c-cd50-76f55858905e",
                        ],
                      },
                      xValue: -10,
                      yValue: -100,
                      xUnit: "vw",
                      yUnit: "vh",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-n-12",
                    actionTypeId: "TRANSFORM_ROTATE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout415_card.card-2",
                        selectorGuids: [
                          "50c8a354-473a-4c1c-cd50-76f55858905a",
                          "50c8a354-473a-4c1c-cd50-76f55858905e",
                        ],
                      },
                      zValue: -30,
                      xUnit: "DEG",
                      yUnit: "DEG",
                      zUnit: "deg",
                    },
                  },
                ],
              },
            ],
          },
        ],
        createdOn: 1690982559519,
      },
      "a-2": {
        id: "a-2",
        title: "Layout 415 Card [Scroll] [Mobile]",
        continuousParameterGroups: [
          {
            id: "a-2-p",
            type: "SCROLL_PROGRESS",
            parameterLabel: "Scroll",
            continuousActionGroups: [
              {
                keyframe: 20,
                actionItems: [
                  {
                    id: "a-2-n",
                    actionTypeId: "TRANSFORM_ROTATE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout415_card.card-0",
                        selectorGuids: [
                          "50c8a354-473a-4c1c-cd50-76f55858905a",
                          "50c8a354-473a-4c1c-cd50-76f55858905f",
                        ],
                      },
                      zValue: 0,
                      xUnit: "DEG",
                      yUnit: "DEG",
                      zUnit: "deg",
                    },
                  },
                  {
                    id: "a-2-n-2",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout415_card.card-0",
                        selectorGuids: [
                          "50c8a354-473a-4c1c-cd50-76f55858905a",
                          "50c8a354-473a-4c1c-cd50-76f55858905f",
                        ],
                      },
                      yValue: 0,
                      xUnit: "PX",
                      yUnit: "vh",
                      zUnit: "PX",
                    },
                  },
                ],
              },
              {
                keyframe: 35,
                actionItems: [
                  {
                    id: "a-2-n-3",
                    actionTypeId: "TRANSFORM_ROTATE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout415_card.card-0",
                        selectorGuids: [
                          "50c8a354-473a-4c1c-cd50-76f55858905a",
                          "50c8a354-473a-4c1c-cd50-76f55858905f",
                        ],
                      },
                      zValue: -10,
                      xUnit: "DEG",
                      yUnit: "DEG",
                      zUnit: "deg",
                    },
                  },
                  {
                    id: "a-2-n-4",
                    actionTypeId: "TRANSFORM_ROTATE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout415_card.card-1",
                        selectorGuids: [
                          "50c8a354-473a-4c1c-cd50-76f55858905a",
                          "50c8a354-473a-4c1c-cd50-76f55858905d",
                        ],
                      },
                      zValue: 3,
                      xUnit: "DEG",
                      yUnit: "DEG",
                      zUnit: "deg",
                    },
                  },
                  {
                    id: "a-2-n-5",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout415_card.card-0",
                        selectorGuids: [
                          "50c8a354-473a-4c1c-cd50-76f55858905a",
                          "50c8a354-473a-4c1c-cd50-76f55858905f",
                        ],
                      },
                      yValue: -120,
                      xUnit: "PX",
                      yUnit: "vh",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-2-n-6",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout415_card.card-1",
                        selectorGuids: [
                          "50c8a354-473a-4c1c-cd50-76f55858905a",
                          "50c8a354-473a-4c1c-cd50-76f55858905d",
                        ],
                      },
                      yValue: 0,
                      zValue: null,
                      xUnit: "PX",
                      yUnit: "vh",
                      zUnit: "px",
                    },
                  },
                ],
              },
              {
                keyframe: 50,
                actionItems: [
                  {
                    id: "a-2-n-7",
                    actionTypeId: "TRANSFORM_ROTATE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout415_card.card-1",
                        selectorGuids: [
                          "50c8a354-473a-4c1c-cd50-76f55858905a",
                          "50c8a354-473a-4c1c-cd50-76f55858905d",
                        ],
                      },
                      zValue: -10,
                      xUnit: "DEG",
                      yUnit: "DEG",
                      zUnit: "deg",
                    },
                  },
                  {
                    id: "a-2-n-8",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout415_card.card-2",
                        selectorGuids: [
                          "50c8a354-473a-4c1c-cd50-76f55858905a",
                          "50c8a354-473a-4c1c-cd50-76f55858905e",
                        ],
                      },
                      yValue: 0,
                      xUnit: "PX",
                      yUnit: "vh",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-2-n-9",
                    actionTypeId: "TRANSFORM_ROTATE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout415_card.card-2",
                        selectorGuids: [
                          "50c8a354-473a-4c1c-cd50-76f55858905a",
                          "50c8a354-473a-4c1c-cd50-76f55858905e",
                        ],
                      },
                      zValue: 6,
                      xUnit: "DEG",
                      yUnit: "DEG",
                      zUnit: "deg",
                    },
                  },
                  {
                    id: "a-2-n-10",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout415_card.card-1",
                        selectorGuids: [
                          "50c8a354-473a-4c1c-cd50-76f55858905a",
                          "50c8a354-473a-4c1c-cd50-76f55858905d",
                        ],
                      },
                      yValue: -120,
                      zValue: null,
                      xUnit: "PX",
                      yUnit: "vh",
                      zUnit: "vh",
                    },
                  },
                ],
              },
              {
                keyframe: 65,
                actionItems: [
                  {
                    id: "a-2-n-11",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout415_card.card-2",
                        selectorGuids: [
                          "50c8a354-473a-4c1c-cd50-76f55858905a",
                          "50c8a354-473a-4c1c-cd50-76f55858905e",
                        ],
                      },
                      yValue: -120,
                      xUnit: "PX",
                      yUnit: "vh",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-2-n-12",
                    actionTypeId: "TRANSFORM_ROTATE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout415_card.card-2",
                        selectorGuids: [
                          "50c8a354-473a-4c1c-cd50-76f55858905a",
                          "50c8a354-473a-4c1c-cd50-76f55858905e",
                        ],
                      },
                      zValue: -10,
                      xUnit: "DEG",
                      yUnit: "DEG",
                      zUnit: "deg",
                    },
                  },
                ],
              },
            ],
          },
        ],
        createdOn: 1690982559519,
      },
    },
    site: {
      mediaQueries: [
        { key: "main", min: 992, max: 10000 },
        {
          key: "medium",
          min: 768,
          max: 991,
        },
        { key: "small", min: 480, max: 767 },
        { key: "tiny", min: 0, max: 479 },
      ],
    },
  };
}

// eslint-disable-next-line import/no-default-export
export default getEvents;
